module.exports = __webpack_public_path__ + "img/ic_32_workout_intensity-medium.40cc9ece.svg";